import { useEffect } from "react";

export const useSEO = ({ title, description, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (sel, val) => {
      const el = document.head.querySelector(sel);
      if (el && val) el.setAttribute("content", val);
    };
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    if (canonical) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }
    window.scrollTo(0, 0);
  }, [title, description, canonical]);
};
